import { MainPageBlockInput, MainPageConfigInfoInput } from '@@partner:graphql/mutation/mainPageConfig/saveMainPageConfig.gql'
import type { MainPageBlock, MainPageConfig, RemoteMainPageConfig } from '@@partner:types:app'
import type { GQL_ID } from '@@partner:types:graphql'

import { mergeLeft } from 'merge-left-utils'

export type MainPageBlockForm = Omit<MainPageBlock, 'type'> & {
  type: string | null
}

export interface MainPageFormState extends Omit<MainPageConfig, 'id' | 'created_at' | 'updated_at' | 'blocks'> {
  id?: GQL_ID
  blocks: MainPageBlockForm[]
}

export const MAIN_PAGE_CONFIG_DEFAULT_STATE: MainPageFormState = {
  id: undefined,
  name: '',
  type: 'delivery',
  isDefault: false,
  is_active: false,
  activeFrom: undefined,
  activeUntil: undefined,
  blocks: []
}

export const makeMainPageFormState = (mainPageConfig?: MainPageConfig): MainPageFormState => {
  return mergeLeft<MainPageFormState>(MAIN_PAGE_CONFIG_DEFAULT_STATE, {
    ...mainPageConfig
  })
}

export const mapStateToApiVariable = (state: MainPageFormState): MainPageConfigInfoInput => ({
  id:  state.id,
  name: state.name,
  type: state.type,
  is_active: state.is_active,
  activeFrom: state.activeFrom ? state.activeFrom.getTime() : null,
  activeUntil: state.activeUntil ? state.activeUntil?.getTime() : null,
  blocks: state.blocks.map((block) => {
    if (block.type !== null) {
      return {
        ...block,
        payload: block.payload ? JSON.stringify(block.payload) : null
      }
    }
  }).filter((block) => block !== undefined) as MainPageBlockInput[]
})

export const mapApiDataToState = (data: RemoteMainPageConfig): MainPageFormState => ({
  id: data.id,
  name: data.name,
  type: data.type,
  isDefault: data.isDefault,
  is_active: data.is_active,
  activeFrom: data.activeFrom ? new Date(data.activeFrom) : undefined,
  activeUntil: data.activeUntil ? new Date(data.activeUntil) : undefined,
  blocks: data.blocks.map((block) => ({
    ...block,
    payload: block.payload ? JSON.parse(block.payload) : null
  }))
})
